import React from 'react';
import Accordion, { AccordionProps } from '../Accordion';
import Button from '../Button';
import TrashIcon from '../Icons/TrashIcon';

function AccordionCMS({
  handleDelete,
  dataTestId,
  ...props
}: { handleDelete: () => void; dataTestId?: string } & Omit<AccordionProps, 'rightSection'>) {
  const RightSection = () => {
    return (
      <Button
        className="bg-white text-supportiveRed flex items-center text-xs border border-supportiveRed !h-[32px] !rounded-sm ml-8"
        data-testid={dataTestId}
        onClick={(e) => {
          e.stopPropagation();
          handleDelete();
        }}
      >
        <span className="mt-[2px] mr-1">
          <TrashIcon size={16} fill="#CE181E" />
        </span>
        HAPUS
      </Button>
    );
  };
  return <Accordion {...props} rightSection={() => <RightSection />} />;
}

export default AccordionCMS;
